import { Icon } from '@twilio/flex-ui-core'
import * as FlexWebChat from '@twilio/flex-webchat-ui'
import React, { Component } from 'react'

export class CustomHeader extends Component {
  render() {

    const imageURL = process.env.REACT_APP_URL + 'img/mobly-logo.png';
    // const imageURL = this._getImageURL()
    return (
      <div className="custom-header">
        <img alt="Mobly" className="custom-header__logo" src={imageURL} />
        <div className="custom-header__actions">
          <div className="custom-header__actions__button custom-header__actions__button--minimize" onClick={this._minimize}>
            <Icon icon="Minus" />
          </div>
          <div className="custom-header__actions__button custom-header__actions__button--close" onClick={this._close}>
            <Icon icon="Close" />
          </div>
        </div>
      </div>
    )
  }

  setAwaitingTime = async () => {
    try {
      const state = this.props.manager.store.getState()
      const { session} = state.flex
      const { channelSid, tokenPayload } = session
  
      const body = {
        channelSid,
        Token: tokenPayload?.token
      }
      const options = {
        method: "POST",
        body: new URLSearchParams(body),
        headers: {
        "Content-Type": "application/x-www-form-urlencoded"
        }
      }

      await fetch('https://atendimento-twilio-functions-7351.twil.io/timerBot/addAwaitingUserTimeOnTask', options)
    } catch (error) {
      console.error(error)
    }
  }

  _getImageURL = () => {
    return `${process.env.REACT_APP_URL}img/mobly-logo.png`
  }

  _minimize = async () => {
    FlexWebChat.Actions.invokeAction('ToggleChatVisibility')
    await this.setAwaitingTime()
  }

  _close = async () => {
    try{
      await this.setAwaitingTime()
      FlexWebChat.Actions.invokeAction('ToggleChatVisibility')
      const state = this.props.manager.store.getState()
      const {chat, session} = state.flex
      const { channelSid, tokenPayload } = session
      const { attributes } = chat.channels[channelSid].source
  
      const body = {
        channelSid,
        attributes: JSON.stringify(attributes),
        Token: tokenPayload?.token
      }
  
      const options = {
        method: "POST",
        body: new URLSearchParams(body),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
      await fetch('https://service-webchat-customerside-2078.twil.io/end-task-by-customer', options)
    }catch(err){
      console.error(err)//Catch vazio apenas para não quebrar a tela do cliente
    }
    FlexWebChat.Actions.invokeAction('RestartEngagement')
  }
}
